import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class AddNoteToContractCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  async run(contract_id: number, reason: string, user_id: number, staff_username: string): Promise<any> {
    let args = {
      contract_id: contract_id,
      reason: reason,
      user_id: user_id,
      staff_username: staff_username
    };
    try {
      const result = await this.dispatcher.dispatch('add.note.to.contract', args);
      return result;
    } catch(error) {
      console.error('Error al añadir nota al contrato', error)
      throw error;
    }
  }
}
